/* eslint-disable no-return-assign */
import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import AdminReportUserPage from 'src/pages/AdminControl/ReportsAdmin/AdminReportUserPage'
import administratorService from 'src/services/administratorService'
import reportsService from 'src/services/reportsService'
import { ContextDownload } from 'src/context/ContextDownload'
import { Context } from 'src/context/Contex'
import swal from 'sweetalert'
import { loaderService } from 'src/services/loaderService'

const AdminReportUserContainer = () => {
  const [users, setUsers] = useState([])
  const { idReport } = useContext(ContextDownload)
  const { permisos } = useContext(Context)

  const history = useHistory()

  const COLORS = [
    {
      checked: true,
      color: 'primary',
      tipo_compartir: 'Ver',
      estado: 1,
    },
    {
      checked: true,
      color: 'secondary',
      tipo_compartir: 'Editar',
      estado: 2,
    },
    {
      checked: false,
      color: 'disable',
      tipo_compartir: 'null',
      estado: 'null',
    },
  ]

  const columns = [
    { title: 'Permiso', field: 'permiso' },
    { title: 'Nombre', field: 'name' },
    { title: 'Apellido', field: 'apellido' },
    { title: 'Correo', field: 'mail' },
    { title: 'id', field: 'id', hidden: true },
    { title: 'table_id', field: 'table_id', hidden: true },
  ]

  /*= =======================================================================
  Get Users
======================================================================== */
  const getUsers = async () => {
    const result = []
    administratorService
      .getUsers()
      .then(async ({ data }) => {
        const { data: dataReport } = await reportsService.getPermitsReport(
          idReport,
        )
        if (data.data.length > 0 && dataReport.length > 0) {
          data.data.forEach((user) => {
            const indexPermit = dataReport.find(
              (item) => item.usuario_id === user.id,
            )
            result.push({
              name: user.nombre,
              apellido: user.apellido,
              mail: user.correo,
              estado: user.estado,
              usuario_id: user.id,
              reporte_id: idReport,
              table_id: indexPermit?.id,
              permiso: indexPermit?.tipo_compartir || 'null',
              tableData: {
                ...(indexPermit !== undefined &&
                indexPermit?.tipo_compartir === 'Ver'
                  ? COLORS[0]
                  : indexPermit?.tipo_compartir === 'Editar'
                  ? COLORS[1]
                  : COLORS[2]),
              },
            })
          })
        }
        setUsers(result)
        loaderService.hide()
      })
      .catch((error) => {
        console.log(error)
        loaderService.hide()
      })
  }

  useEffect(() => {
    loaderService.show()
    getUsers()
  }, [])

  if (!idReport) {
    history.push('/admin/reports')
  }

  const onUpdatePermit = async (selectedRow, obj) => {
    loaderService.show()
    const response = await reportsService.postPermitUser({
      usuario_id: selectedRow.usuario_id,
      reporte_id: selectedRow.reporte_id,
      tipo_compartir: obj.tipo_compartir,
    })
    if (response.success === 1) {
      setUsers((prev) => [
        ...prev.slice(0, selectedRow.tableData.id),
        (prev[selectedRow.tableData.id] = {
          ...prev[selectedRow.tableData.id],
          permiso: obj.tipo_compartir,
          table_id: response.id,
        }),
        ...prev.slice(selectedRow.tableData.id + 1),
      ])
    } else {
      swal(`${response.error}`, { icon: 'warning' })
      getUsers()
    }
    loaderService.hide()
  }

  const onDeletePermit = async (selectedRow, obj) => {
    loaderService.show()
    const response = await reportsService.deletePermit(selectedRow.table_id)
    if (response.success === 0) {
      swal(`${response.error}`, { icon: 'warning' })
      getUsers()
    }
    loaderService.hide()
  }

  const handleOnChange = (selectedRow) => {
    let obj = {}
    const newData = users
    const index = COLORS.findIndex(
      (item) => item.tipo_compartir === selectedRow.tableData.tipo_compartir,
    )

    if (index !== -1 && selectedRow) {
      obj = Object.assign(
        newData[selectedRow.tableData.id].tableData,
        COLORS[(index + 1) % 3],
      )
      setUsers((prev) => [
        ...prev.slice(0, selectedRow.tableData.id),
        (prev[selectedRow.tableData.id] = {
          ...prev[selectedRow.tableData.id],
          permiso: obj.tipo_compartir,
          tableData: {
            id: selectedRow.tableData.id,
            ...obj,
          },
        }),
        ...prev.slice(selectedRow.tableData.id + 1),
      ])
    }
    if (
      selectedRow.tableData.tipo_compartir === 'Ver' ||
      selectedRow.tableData.tipo_compartir === 'Editar'
    ) {
      onUpdatePermit(selectedRow, obj)
    } else {
      onDeletePermit(selectedRow, obj)
    }
  }

  return (
    <>
      <AdminReportUserPage
        users={users}
        columns={columns}
        idReport={idReport}
        permisos={permisos}
        handleOnChange={handleOnChange}
      />
    </>
  )
}

export default AdminReportUserContainer
